<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Borç Raporu</h1>
      <div class="SayfaBtn el-button-group" v-if="Liste">
        <el-button size="small" type="default" @click="Yazdir" :disabled="lo">Yazdır</el-button>
        <!--        <el-button size="small" type="default" @click="Indir" :disabled="lo">İndir</el-button>-->
      </div>
    </div>
    <div class="SayfaIcerik" v-loading="lo">
      <div class="yazdirtable" v-if="Liste">
        <h1>
          {{ SayfaAdi }}
          <small class="d-block">{{ Tarih }}</small>
        </h1>
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Cari</th>
            <th v-if="reAlt.Devir!='0,00'" class="text-right">Devir</th>
            <th class="text-right" v-for="h in tableHizmetler ">{{ h }}</th>
            <th class="text-right">Toplam</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="d in Liste">
            <td>{{ d.Unvan }}</td>
            <td v-if="reAlt.Devir!='0,00'"  class="text-right">{{ d.Devir }}</td>
            <td class="text-right" v-for="(v,h) in tableHizmetler ">{{ d.Hizmet[v] }}</td>
            <td class="text-right">{{ d.Toplam }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th></th>
            <th v-if="reAlt.Devir!='0,00'" class="text-right">{{ reAlt.Devir }}</th>
            <th class="text-right" v-for="(k,v) in tableHizmetler">{{ reAlt[k] }}</th>
            <th class="text-right">{{ reAlt.Toplam }}</th>
          </tr>
          </tfoot>
        </table>
      </div>
      <el-row>
        <el-col :span="19" class="pr-10">
          <el-alert
              v-if="!Liste"
              title="Filtreleme Yapınız"
              type="info"
              :closable="false"
              description="Verilere erişebilemek için lütfen filtreleme yapınız">
          </el-alert>
          <el-table
              v-if="Liste"
              :data="Liste"
              class="table-xs table-hover yazdirma"
              :height="Height"
              show-summary
              :summary-method="TableFooter">
            <el-table-column label="Cari" prop="Unvan"></el-table-column>
            <el-table-column label="Devir" prop="Devir" width="100" align="right"></el-table-column>
            <el-table-column
                :label="value"
                width="150"
                v-for="(value,index) in tableHizmetler"
                align="right">
              <template slot-scope="scope">{{ scope.row.Hizmet[value] }}</template>
            </el-table-column>
            <el-table-column label="Toplam" prop="Toplam" width="100" align="right"></el-table-column>
          </el-table>
        </el-col>
        <el-col :span="5" class="yazdirma">
          <div class="RaporOlay">
            <h1>Filtreleme</h1>
            <el-form :rules="FormHata" :model="Form"
                     @submit.prevent.native="Getir"
                     ref="RaporForm">
              <el-form-item prop="Proje_id" v-if="this.Projeler.length>1">
                <el-select v-model="Form.Proje_id" placeholder="Proje Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Projeler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Grup_id">
                <el-select v-model="Form.Grup_id" placeholder="Grup Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Gruplar"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Hizmet_id">
                <el-select v-model="Form.Hizmet_id" placeholder="Hizmet Seçiniz" clearable filterable>
                  <el-option
                      v-for="item in Hizmetler"
                      :key="item.id"
                      :label="item.Adi"
                      :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="Tarih">
                <el-date-picker
                    :clearable="false"
                    v-model="Form.Tarih"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="Başlangıç Tarihi"
                    end-placeholder="Bitiş Tarihi"
                    format="dd.MM.yyyy">
                </el-date-picker>
              </el-form-item>

              <el-button type="primary" class="btn-block mt-3" size="medium" @click="Getir()"
                         icon="el-icon-check">Rapor Oluştur
              </el-button>
            </el-form>
          </div>

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
export default {
  data() {
    return {
      Height: null,
      lo: false,
      AltToplam: null,
      SayfaAdi: 'Borç Raporu',
      Liste: null,
      Projeler: null,
      Gruplar: null,
      Hizmetler: null,
      reAlt: null,
      ExcelData: null,
      tableHizmetler: null,
      TableAlt: null,
      GrupData: null,
      Tarih: null,
      Form: {
        Tur: "2",
        Tarih: [],
        Proje_id: null,
        Grup_id: null
      },
      FormHata: {
        Tarih: [{required: true, message: "Tarih seçiniz", trigger: 'blur'}],
      },
    }
  },
  methods: {

    Indir(evt) {

      const ws = XLSX.utils.json_to_sheet(this.ExcelData);
      const wb = XLSX.utils.book_new();
      ws['!cols'] = [
        {wch: 5},
        {wch: 12},
        {wch: 20},
        {wch: 50},
        {wch: 12},
        {wch: 12},
        {wch: 12},
      ];

      wb.Props = {
        Title: this.SayfaAdi,
        Author: "MUDU APP",
        Manager: "MUDU APP",
        Company: "MUDU",
        Category: "Finans",
        Keywords: "Mudu",
        Comments: this.SayfaAdi,
      };

      XLSX.utils.book_append_sheet(wb, ws, this.SayfaAdi);
      XLSX.writeFile(wb, this.SayfaAdi + ".xlsx");
    },
    Getir() {
      // this.lo = true
      this.$store.dispatch("Post", {...this.Form, path: 'rapor/borc'})
          .then(response => {
            if (response.Durum === "OK") {
              this.lo = false
              this.Liste = response.Data
              this.ExcelData = response.ExcelData
              this.tableHizmetler = response.Hizmetler
              this.TableAlt = response.TableAlt
              this.AltToplam = response.AltToplam
              this.reAlt = response.reAlt
              this.Tarih = response.Tarih
            }
          })
    },
    Yazdir() {
      this.$prompt('Yazdırılacak sayfanın adını değişebilirsiniz.', 'Sayfa Adı', {
        confirmButtonText: 'Yazıcıya Gönder',
        cancelButtonText: 'Vazgeç',
        inputValue: this.SayfaAdi,
        inputPlaceholder: 'Yazdırma Sayfası'
      }).then(({value}) => {
        this.SayfaAdi = value;
        this.YaziciyaGonder(value);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Yazdırma İptal Edildi'
        });
      });
    },
    YaziciyaGonder() {
      setTimeout(() => {
        window.print();
      }, 100);
    },

    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'grup'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Gruplar = response.Liste
            }
          })
      this.$store.dispatch("Get", {path: 'hizmet'})
          .then(response => {
            if (response.Durum === "OK") {
              this.Hizmetler = response.Liste
            }
          })
    },
    TableFooter() {
      // const sums = [];

      return this.TableAlt;
    },
  },
  created() {

    this.SayfaYukle()
    var Gun = new Date();
    this.Form.Tarih[0] = new Date(Gun.getFullYear(), Gun.getMonth(), 1);
    this.Form.Tarih[1] = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
    this.Projeler = this.$store.state.Proje
    this.Form.Proje_id = this.$store.state.Proje_id

    this.Height = window.innerHeight - 111
    this.$store.dispatch("title", "Borç Raporu");

  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Raporlama/BorcRaporu.vue